module.exports = __webpack_public_path__ + "static/media/Date.5905f184.svg";